module.exports = __webpack_public_path__ + "img/scene23.b4171346.gif";